import { VehicleImagesSchema } from "@repo/types";
import { z } from "zod";

import errorMessages from "../error-messages";

const TVehicleType = ["GAS", "HYBRID", "ELECTRIC"] as const;

export const VehicleSchema = z.object({
  vin: z.string().optional(),
  carType: z.enum(["A", "B", "C"] as const),
  vehicleCode: z.string().refine((value) => value.length > 0, {
    message: errorMessages.required,
  }),
  marque: z.string().refine((value) => value.length > 0, {
    message: errorMessages.required,
  }),
  model: z.string().refine((value) => value.length > 0, {
    message: errorMessages.required,
  }),
  toRetrieve: z.nullable(z.boolean()),
  imagesBefore: VehicleImagesSchema.nullable().optional(),
  imagesAfter: VehicleImagesSchema.nullable().optional(),
  garageImages: z
    .object({
      photo1: z.string(),
      photo2: z.string(),
      photo3: z.string(),
      photo4: z.string(),
      photo5: z.string(),
      photo6: z.string(),
    })
    .or(z.undefined()),
  type: z.enum(TVehicleType),
});

export const VehicleUpdateSchema = VehicleSchema.partial().extend({
  id: z.number(),
});
export type UpdateVehiculeSchemaType = z.infer<typeof VehicleUpdateSchema>;
